// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/droid-serif/DroidSerif-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling: global base rules */

@font-face {
  /* serif font: text, data, etc. - NOT USED FOR NOW */
  font-family: DroidSerif;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

html {
  /* Scale origin: 87.5% of 16px (browser default) = 14px
     Using modular scale https://alistapart.com/article/more-meaningful-typography
     Ratio: minor third, 1.2 https://www.modularscale.com/?14&px&1.2 */
  font-size: 87.5%;
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
  /* default font: sans-serif */
  color: hsl(0, 0%, 10%);
  /* default text color (dark gray) */
  box-sizing: border-box;
  /* default box model */
}

*,
*:before,
*:after {
  /* default box model,
    /  from https://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/ */
  box-sizing: inherit;
}

body {
  font-size: 1rem;
  /* = 14px, default size */
  color: hsl(0, 0%, 10%);
  font-family: noto-sans-display, aktiv-grotesk, sans-serif;
}

html,
body,
#mainView {
  margin: 0;
  padding: 0;
  height: 100%;
}

button:focus,
input:focus,
textarea:focus {
  /* reset browser default behavior */
  outline: none;
}

input::placeholder {
  color: hsl(0, 0%, 70%);
}
`, "",{"version":3,"sources":["webpack://./css/base.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,oDAAoD;EACpD,uBAAuB;EACvB,4CAA8D;AAChE;;AAEA;EACE;;sEAEoE;EACpE,gBAAgB;EAChB,yDAAyD;EACzD,6BAA6B;EAC7B,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;EAGE;kGACgG;EAChG,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Styling: global base rules */\n\n@font-face {\n  /* serif font: text, data, etc. - NOT USED FOR NOW */\n  font-family: DroidSerif;\n  src: url('../assets/fonts/droid-serif/DroidSerif-Regular.ttf');\n}\n\nhtml {\n  /* Scale origin: 87.5% of 16px (browser default) = 14px\n     Using modular scale https://alistapart.com/article/more-meaningful-typography\n     Ratio: minor third, 1.2 https://www.modularscale.com/?14&px&1.2 */\n  font-size: 87.5%;\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n  /* default font: sans-serif */\n  color: hsl(0, 0%, 10%);\n  /* default text color (dark gray) */\n  box-sizing: border-box;\n  /* default box model */\n}\n\n*,\n*:before,\n*:after {\n  /* default box model,\n    /  from https://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/ */\n  box-sizing: inherit;\n}\n\nbody {\n  font-size: 1rem;\n  /* = 14px, default size */\n  color: hsl(0, 0%, 10%);\n  font-family: noto-sans-display, aktiv-grotesk, sans-serif;\n}\n\nhtml,\nbody,\n#mainView {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\nbutton:focus,\ninput:focus,\ntextarea:focus {\n  /* reset browser default behavior */\n  outline: none;\n}\n\ninput::placeholder {\n  color: hsl(0, 0%, 70%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
